export default __webpack_public_path__ + "static/jura-gui-b34951f24787211942b3fe031714b885.png";